<header class="admin-header">
  <!--<a href="javascript:void(0);" class="sidebar-toggle"  (click)="onMobileToggaleSideBarOpen()" data-toggleclass="sidebar-open" data-target="body">001 </a>
  <nav class="my-auto mr-auto ">
    <ul class="nav align-items-center">
      <li class="nav-item">
        <a class="nav-link sidebar-toggle sidebar"  (click)="onToggaleSideBar()" data-target="javascript:void(0);siteSearchModal" data-toggle="modal" href="javascript:void(0);">
        </a>
      </li>
    </ul>
  </nav>-->

  <!-- Left spacer (balances right nav for true centering) -->
  <div class="header-left"></div>

  <!-- Global Search (centered) -->
  <div class="header-center">
  <app-global-search></app-global-search>
</div>

<nav class="header-right">
  <ul class="nav align-items-center">
    <li class="mr-3 nav-item">
      <!-- <mat-form-field class="form-control no-boarder-field">
      <mat-select #selectRef="matSelect" placeholder="{{getSelectedCompanyName()}}">
        <ng-template matSelectTrigger>
          {{ getSelectedCompanyName() }}
          fdsfsd
        </ng-template>


        <div class="table-header">
          <span>Select</span>
          <span>Office Name</span>
          <span>Current Office</span>
        </div>

        <mat-option
          *ngFor="let option of companyListSelection"
          [value]="option.value"
          (click)="$event.stopPropagation()"
          >
          <div class="company-option">
            <span>
              <mat-checkbox
                [(ngModel)]="option.selected"
                (click)="$event.stopPropagation()"
                >
              </mat-checkbox>
            </span>
            <span>{{ option.name }}</span>
            <span>
              <mat-radio-group [(ngModel)]="currentCompanyId">
                <mat-radio-button
                  [value]="option.value"
                  (click)="$event.stopPropagation()"
                ></mat-radio-button>
              </mat-radio-group>
            </span>
          </div>
        </mat-option>

        <mat-option>
          <div style="display: flex; justify-content: flex-end" class="m-4">
            <button
              mat-button
              color="primary"
              class="btn add-role-btn"
              (click)="onOfficeSettingApply()"
              >
              Apply
            </button>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field> -->
  </li>

  <li class="nav-item office-selector-wrapper">
    <button class="office-selector-trigger"
      (click)="toggleOfficePanel()"
      [class.open]="showOfficePanel"
      [class.single]="companyListSelection.length <= 1">
      <mat-icon class="office-icon">business</mat-icon>
      <span class="office-name">{{ getSelectedCompanyName() }}</span>
      @if (companyListSelection.length > 1) {
        <mat-icon class="office-chevron">
          {{ showOfficePanel ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      }
    </button>

    <!-- Office Selection Panel -->
    @if (showOfficePanel) {
      <div class="office-panel" (clickOutside)="closeOfficePanel()">
        <!-- Panel Header -->
        <div class="office-panel-header">
          <span class="office-panel-title">Switch Office</span>
          <span class="office-panel-subtitle">{{ lastSelectedOffices.length }} selected</span>
        </div>
        <!-- Office Tree -->
        <div class="office-panel-list">
          @for (option of groupOffices; track option) {
            <ng-container *ngTemplateOutlet="officeTreeNode; context: { $implicit: option, level: 0 }">
            </ng-container>
          }
          <ng-template #officeTreeNode let-option let-level="level">
            <!-- Office Row -->
            <div class="office-row"
              [class.is-default]="option.id == currentCompanyId"
              [class.is-selected]="lastSelectedOffices.includes(option.id)"
              [class.is-parent]="option.is_parent"
              [class.is-unassigned]="option.unassigned"
              [style.padding-left.px]="16 + (level * 20)">
              <!-- Left side: icon + name -->
              <div class="office-row-info" (click)="setDefaultOffice(option.id); $event.stopPropagation()">
                <mat-icon class="office-row-icon">
                  {{ option.is_parent ? 'apartment' : 'location_city' }}
                </mat-icon>
                <div class="office-row-text">
                  <span class="office-row-name">{{ option.name }}</span>
                  @if (option.id == currentCompanyId) {
                    <span class="office-row-badge">Default</span>
                  }
                </div>
              </div>
              <!-- Right side: selection toggle -->
              @if (!option.unassigned) {
                <div class="office-row-actions">
                  <!-- Default star -->
                  <button class="office-star-btn"
                    [class.is-default]="option.id == currentCompanyId"
                    (click)="setDefaultOffice(option.id); $event.stopPropagation()"
                    matTooltip="Set as default">
                    <mat-icon>{{ option.id == currentCompanyId ? 'star' : 'star_border' }}</mat-icon>
                  </button>
                  <!-- Selection toggle -->
                  <button class="office-toggle-btn"
                    [class.is-selected]="lastSelectedOffices.includes(option.id)"
                    (click)="selectOffice(option.id); $event.stopPropagation()"
                    matTooltip="{{ lastSelectedOffices.includes(option.id) ? 'Deselect office' : 'Select office' }}">
                    <mat-icon>{{ lastSelectedOffices.includes(option.id) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  </button>
                </div>
              }
            </div>
            <!-- Recursive children -->
            @if (option.children && option.children.length > 0) {
              @for (child of option.children; track child) {
                <ng-container *ngTemplateOutlet="officeTreeNode; context: { $implicit: child, level: level + 1 }">
                </ng-container>
              }
            }
          </ng-template>
        </div>
      </div>
    }
  </li>

  <li class="nav-item">
    <div [matMenuTriggerFor]="quickCreateMenu"
      class="img_wrap quick-create-trigger"
      matTooltip="Quick Create"
      matTooltipPosition="below"
      aria-label="Quick Create menu">
      <mat-icon class="quick-create-icon">add_circle</mat-icon>
    </div>
    <mat-menu #quickCreateMenu="matMenu" class="quick-create">
      <app-quick-create></app-quick-create>
    </mat-menu>
  </li>

  <!--<li class="nav-item">
  <div class="img_wrap">
    <img src="../../../../assets/img/insights_icon.svg" alt="" class="icon" />
  </div>
</li>-->
<li class="nav-item">
  <app-task-dropdown></app-task-dropdown>

  <!-- <div class="img_wrap">
  <img src="../../../../assets/img/tasks_icons.svg" alt="" class="icon" />
</div> -->
</li>
<li class="nav-item">
  <app-calculator></app-calculator>
</li>

<li class="nav-item">
  <div class="img_wrap"
    matTooltip="Screenshot"
    matTooltipPosition="below"
    (click)="startScreenshot()">
    <mat-icon class="icon text-white">photo_camera</mat-icon>
  </div>
</li>

<!-- Email Sidebar Trigger -->
<li class="nav-item">
  <div class="mail-trigger"
    [class.has-unread]="((emailUnreadCount$ | async) || 0) > 0"
    [class.active]="showEmailSidebar">
    <a (click)="toggleEmailSidebar()" class="nav-link">
      <mat-icon class="icon text-white mail-icon">email</mat-icon>
      @if (((emailUnreadCount$ | async) || 0) > 0) {
        <span class="notification-counter email-counter">
          {{ ((emailUnreadCount$ | async) || 0) > 99 ? '99+' : (emailUnreadCount$ | async) }}
        </span>
      }
    </a>

    <!-- Email Sidebar Panel -->
    <app-header-email-sidebar
      [isOpen]="showEmailSidebar"
      (onClose)="closeEmailSidebar()"
      (onEmailClick)="onEmailItemClick($event)">
    </app-header-email-sidebar>
  </div>
</li>

<!-- Reminders Panel Trigger -->
<li class="nav-item">
  <div class="reminders-trigger"
    [class.has-unread]="((reminderUnreadCount$ | async) || 0) > 0"
    [class.has-urgent]="(hasUrgentReminders$ | async)">
    <a (click)="toggleRemindersPanel()" class="nav-link">
      <!-- Show alarm icon when urgent, calendar icon otherwise -->
      @if ((hasUrgentReminders$ | async)) {
        <mat-icon alt="Urgent Reminders" class="icon text-white urgent-alarm-icon">alarm</mat-icon>
      } @else {
        <img src="../../../../assets/img/calender_icon.svg" alt="Reminders" class="icon"
          style="filter: hue-rotate(40deg);" />
      }
      @if (((reminderUnreadCount$ | async) || 0) > 0) {
        <span class="notification-counter reminders-counter">
          {{ reminderUnreadCount$ | async }}
        </span>
      }
    </a>

    <!-- Reminders Panel -->
    <app-reminders-panel [isOpen]="showRemindersPanel" (onClose)="closeRemindersPanel()">
    </app-reminders-panel>
  </div>
</li>

<!-- Activity Panel Trigger -->
<li class="nav-item">
  <div class="activity-trigger">
    <a (click)="toggleActivityPanel()" class="nav-link">
      <mat-icon class="icon text-white">history</mat-icon>
    </a>
    <app-activity-panel [isOpen]="showActivityPanel" (onClose)="closeActivityPanel()">
    </app-activity-panel>
  </div>
</li>

<!-- Buddy glance — the web stand-in for the design's tray popover (4b) -->
<li class="nav-item" *ngIf="enableBuddyFeatures">
  <div class="activity-trigger">
    <a (click)="toggleBuddyGlance()" class="nav-link" title="Buddy (Alt+Space)" aria-label="Open Buddy glance">
      <mat-icon class="icon text-white">smart_toy</mat-icon>
    </a>
    <app-buddy-glance [isOpen]="showBuddyGlance" (onClose)="closeBuddyGlance()">
    </app-buddy-glance>
  </div>
</li>

<li class="nav-item">
  <div class="dropdown">
    <a (click)="getNotification(true); resetNotificationCounter();" [matMenuTriggerFor]="notificationMenu"
      #notificationMenuTrigger="matMenuTrigger"
      class="nav-link">
      <a class="nav-link">
        <img src="../../../../assets/img/bell_icon.png" alt="" class="icon" />

        @if (currentNotificationCount != 0) {
          <span class="notification-counter"
          >{{currentNotificationCount}}</span>
        }
      </a>
    </a>
  </div>
</li>




<li class="nav-item dropdown">
  <a class="nav-link" [matMenuTriggerFor]="menu" role="button">
    <!-- <img  matTooltip="{{ user.getFullName() | titlecase }}" src="../../../../assets/img/general_icons/account-circle_24dp_white.svg" alt="" class="avatar_img" /> -->
    <app-profile-avatar [fullName]="user.getFullName()" [userStatusSlug]="currentStatus"
      [profileUrl]="userStaffDetail?.profile_image?.url" [widthSize]="'37px'"
    [heightSize]="'37px'"></app-profile-avatar>

    <!-- <span class="avatar_title">{{
    user.getFullName() | titlecase
  }}</span> -->
  <!-- <span class="mr-2">
  <svg fill="#ff6601" width="20px" height="20px" viewBox="-6.5 0 32 32" version="1.1"
    xmlns="http://www.w3.org/2000/svg" stroke="#ff6601">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <title>dropdown</title>
      <path
        d="M18.813 11.406l-7.906 9.906c-0.75 0.906-1.906 0.906-2.625 0l-7.906-9.906c-0.75-0.938-0.375-1.656 0.781-1.656h16.875c1.188 0 1.531 0.719 0.781 1.656z">
      </path>
    </g>
  </svg>
</span> -->
</a>
<!--        {{user.getNameIntial()}}-->
<div class="dropdown-menu dropdown-menu-right">
  <a class="dropdown-item" href="javascript:void(0);"> Add Account </a>
  <a class="dropdown-item" href="javascript:void(0);">
  Reset Password</a>
  <a class="dropdown-item" href="javascript:void(0);"> Help </a>
  <div class="dropdown-divider"></div>
  <a [routerLink]="['/auth/logout']" routerLinkActive="active" class="dropdown-item" href="javascript:void(0);">
  Logout</a>
</div>
</li>
</ul>
</nav>
</header>

<!-- logout menu -->
<mat-menu #menu="matMenu" class="logout-wrapper" (closed)="onMenuClosed()">
  <div class="row" (click)="$event.stopPropagation()">
    <div class="menu-header">
      <div class="position-relative">
        <app-profile-avatar [fullName]="user.getFullName()" [userStatusSlug]="currentStatus"
          [profileUrl]="userStaffDetail?.profile_image?.url" [widthSize]="'37px'"
        [heightSize]="'37px'"></app-profile-avatar>
      </div>
      <div class="user-info">
        <div class="name">{{ user.getFullName() | titlecase }}</div>
        <div matTooltip="{{ user.getEmail() }}" matTooltipPosition="above" class="d-inline-block email text-truncate"
          style="max-width: 150px;">{{
        user.getEmail() }}</div>
        <app-statistics-dropdown></app-statistics-dropdown>
      </div>
    </div>
    <mat-divider class="mt-2"></mat-divider>

    <!-- Clock In/Out Button -->
    <div class="py-2 col-md-12 logout-items clock-in-out-item"
      (click)="toggleClock(); $event.stopPropagation()"
      [class.disabled]="isClockingInOut"
      [style.pointer-events]="isClockingInOut ? 'none' : 'auto'">
      <span class="cursor-pointer d-flex align-items-center">
        <button class="clock-circle-btn"
          [class.clocked-in]="isCurrentlyClockedIn"
          [class.clocked-out]="!isCurrentlyClockedIn"
          [disabled]="isClockingInOut">
          @if (isClockingInOut) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          @if (!isClockingInOut) {
            <mat-icon>
              {{ isCurrentlyClockedIn ? 'pause' : 'play_arrow' }}
            </mat-icon>
          }
        </button>
        <span class="ml-2 logout-text">
          @if (!isClockingInOut) {
            {{ isCurrentlyClockedIn ? 'Clock Out' : 'Clock In' }}
          }
          @if (isClockingInOut) {
            {{ isCurrentlyClockedIn ? 'Clocking Out...' : 'Clocking In...' }}
          }
        </span>
      </span>
    </div>

    <!-- Time Off Request Button -->
    <div class="py-2 col-md-12 logout-items"
      (click)="openPTORequestDialog(); $event.stopPropagation()">
      <span class="cursor-pointer">
        <mat-icon class="menu-item-icon">beach_access</mat-icon>
        <span class="ml-2 logout-text">Request Time Off</span>
      </span>
    </div>

    <!-- PTO Approval Queue Button -->
    <div class="py-2 col-md-12 logout-items"
      (click)="openPTOApprovalQueueDialog(); $event.stopPropagation()">
      <span class="cursor-pointer">
        <mat-icon class="menu-item-icon">event_note</mat-icon>
        <span class="ml-2 logout-text">PTO Approval</span>
      </span>
    </div>

    <mat-divider></mat-divider>

    @for (item of dropdownItems; track item) {
      <div class="py-2 col-md-12 logout-items"
        (click)="onMenuItemClick(item.action, $event)" [class.disabled]="item.title === 'Logout' && isLogoutInProgress"
        [style.pointer-events]="item.title === 'Logout' && isLogoutInProgress ? 'none' : 'auto'">
        <span class="cursor-pointer">
          <mat-icon class="menu-item-icon">{{ item.iconName }}</mat-icon>
          <span class="ml-2 logout-text">
            @if (item.title === 'Logout') {
              @if (!isLogoutInProgress) {
                {{ item.title }}
              } @else {
                <span class="d-inline-flex align-items-center">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="margin-right: 8px;"></span>
                  Logging out...
                </span>
              }
            } @else {
              {{ item.title }}
            }
          </span>
        </span>
      </div>
    }
  </div>
</mat-menu>


<!-- Notification Menu start -->

<mat-menu #notificationMenu="matMenu" class="notification-menu" [hasBackdrop]="true" (click)="$event.stopPropagation()">

  <!-- Header -->
  <div class="notification-header" (click)="$event.stopPropagation()">
    <div class="d-flex justify-content-between align-items-center px-4 py-3">
      <div class="d-flex align-items-center">
        <span class="header-title">Notifications</span>
      </div>
      <div class="header-actions">
        <span class="only-show-unread mr-2">Only show unread</span>
        <mat-slide-toggle color="warn" class="position-relative " style="top: 7px !important;"
          [checked]="showOnlyUnread" (change)="onUnreadToggleChange($event)">
        </mat-slide-toggle>
        <mat-icon [matMenuTriggerFor]="headerMenu" #notificationMarkAllAsReadMenu="matMenuTrigger">more_vert</mat-icon>
      </div>
    </div>

    <!-- Filter Bar -->
    <div class="filter-bar px-3 py-2">
      <mat-button-toggle-group class="w-100" [value]="currentFilterType" (change)="onFilterChange($event)">
        <mat-button-toggle value="regular" class="flex-grow-1 position-relative">All
          <span class="notification-badge">{{regularUnreadCount}}</span>
        </mat-button-toggle>
        <mat-button-toggle value="watch" class="flex-grow-1 position-relative">Watch
          <span class="notification-badge">{{watchUnreadCount}}</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    @if (currentFilterType === 'watch') {
      <div class="secondary-tab-container d-flex justify-content-end p-2">
        <mat-button-toggle-group [value]="currentFocusTab" (change)="onFocusTabChange($event)">
          <mat-button-toggle value="regular">Regular
            <span class="notification-badge">{{watchRegularUnreadCount}}</span>
          </mat-button-toggle>
          <mat-button-toggle value="focus">Focus
            <span class="notification-badge">{{watchFocusUnreadCount}}</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
        <!-- <div class="d-flex justify-content-center  ">
        <button
          (click)="onResetFilter()"
          class="notification-reset">
          Reset
        </button>
      </div> -->
    </div>
  }
</div>

<!-- Notification Content -->
<div #notificationScroll (scroll)="onScroll()" class="notification-content" (click)="$event.stopPropagation()">
  <div class="notification-group">
    @for (item of NotificationList; track item; let i = $index) {
      <div class="notification-item unread"
        (contextmenu)="onNotificationRightClick($event, item, notificationMarkAsUnReadMenuTrigger)"
        [matMenuTriggerFor]="item.is_seen == 1 ? markAsUnread : null"
        #notificationMarkAsUnReadMenuTrigger="matMenuTrigger"
        (click)="onNotificationClick(item, $event)"
        (menuClosed)="onNotificationMenuClosed()">
        <div class="item-wrapper">
          <div class="item-icon d-flex justify-content-center align-items-start">
            <!-- <div class="current-user-status-icons"> -->
            <app-profile-avatar [profileUrl]="item?.action_by?.profile_image?.url" [userStatusSlug]="currentStatus"
            [fullName]="item?.action_by?.full_name | titlecase"></app-profile-avatar>
          <!-- </div> -->
        </div>
        <div class="item-content">
          <div class="item-header">
            <div class="item-type">
              <span [innerHTML]="item?.title"></span>
              <span class="item-time">{{ item?.created_at_human }}</span>
            </div>
            <ng-container>
              <div class="circle_button pl-1 ">
                @if (item.is_seen == 0) {
                  <button (click)="onMarkAsSeenClick(item.id, $event)" class="svg-button"
                    aria-label="SVG Button">
                    <svg fill="#ff6600" version="1.1" xmlns="http://www.w3.org/2000/svg" width="10px" height="10px"
                      viewBox="-5.32 -5.32 35.97 35.97" stroke="#ff6600">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <g>
                          <path
                            d="M25.334,12.667c0,6.996-5.672,12.667-12.668,12.667C5.672,25.334,0,19.663,0,12.667S5.672,0,12.666,0 C19.662,0,25.334,5.671,25.334,12.667z">
                          </path>
                        </g>
                      </g>
                    </svg>
                  </button>
                }
                <!-- Code for three-dot icon to open the 'Mark as Unread' menu -->
                <!-- <span *ngIf="item.is_seen == 1"  style="display: none;"  class="cursor-pointer">
                <mat-icon [matMenuTriggerFor]="markAsUnread" #notificationMarkAsUnReadMenu="matMenuTrigger"
                (click)="setSelectedNotificationId(item.id)">more_vert</mat-icon>
              </span> -->
            </div>
          </ng-container>
        </div>
        <div class="d-flex justify-content-between">
          <div class="item-title" [innerHTML]="item?.message"></div>
          @if (item.notification_type =='focus_watch') {
            <span>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.9944 15.5C13.9274 15.5 15.4944 13.933 15.4944 12C15.4944 10.067 13.9274 8.5 11.9944 8.5C10.0614 8.5 8.49439 10.067 8.49439 12C8.49439 13.933 10.0614 15.5 11.9944 15.5ZM11.9944 13.4944C11.1691 13.4944 10.5 12.8253 10.5 12C10.5 11.1747 11.1691 10.5056 11.9944 10.5056C12.8197 10.5056 13.4888 11.1747 13.4888 12C13.4888 12.8253 12.8197 13.4944 11.9944 13.4944Z"
                    fill="#ff6600" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 5C7.18879 5 3.9167 7.60905 2.1893 9.47978C0.857392 10.9222 0.857393 13.0778 2.1893 14.5202C3.9167 16.391 7.18879 19 12 19C16.8112 19 20.0833 16.391 21.8107 14.5202C23.1426 13.0778 23.1426 10.9222 21.8107 9.47978C20.0833 7.60905 16.8112 5 12 5ZM3.65868 10.8366C5.18832 9.18002 7.9669 7 12 7C16.0331 7 18.8117 9.18002 20.3413 10.8366C20.9657 11.5128 20.9657 12.4872 20.3413 13.1634C18.8117 14.82 16.0331 17 12 17C7.9669 17 5.18832 14.82 3.65868 13.1634C3.03426 12.4872 3.03426 11.5128 3.65868 10.8366Z"
                    fill="#ff6600" />
                  <line x1="6.5" y1="5" x2="5" y2="2.5" stroke="#ff6600" stroke-width="1" />
                  <line x1="8" y1="4.5" x2="6.5" y2="2" stroke="#ff6600" stroke-width="1" />
                  <line x1="9.5" y1="4.2" x2="8.8" y2="1.5" stroke="#ff6600" stroke-width="1" />
                  <line x1="11" y1="4" x2="10.3" y2="1.3" stroke="#ff6600" stroke-width="1" />
                  <line x1="12.5" y1="3.9" x2="12.5" y2="1.2" stroke="#ff6600" stroke-width="1" />
                  <line x1="14" y1="4" x2="14.7" y2="1.3" stroke="#ff6600" stroke-width="1" />
                  <line x1="15.5" y1="4.2" x2="16.2" y2="1.5" stroke="#ff6600" stroke-width="1" />
                  <line x1="17" y1="4.5" x2="18.5" y2="2" stroke="#ff6600" stroke-width="1" />
                  <line x1="18.5" y1="5" x2="20" y2="2.5" stroke="#ff6600" stroke-width="1" />
                </g>
              </svg>
            </span>
          }
          @if (item.notification_type =='watch') {
            <span>
              <svg viewBox="0 0 24 24" width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.9944 15.5C13.9274 15.5 15.4944 13.933 15.4944 12C15.4944 10.067 13.9274 8.5 11.9944 8.5C10.0614 8.5 8.49439 10.067 8.49439 12C8.49439 13.933 10.0614 15.5 11.9944 15.5ZM11.9944 13.4944C11.1691 13.4944 10.5 12.8253 10.5 12C10.5 11.1747 11.1691 10.5056 11.9944 10.5056C12.8197 10.5056 13.4888 11.1747 13.4888 12C13.4888 12.8253 12.8197 13.4944 11.9944 13.4944Z"
                    fill="#ff6600" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 5C7.18879 5 3.9167 7.60905 2.1893 9.47978C0.857392 10.9222 0.857393 13.0778 2.1893 14.5202C3.9167 16.391 7.18879 19 12 19C16.8112 19 20.0833 16.391 21.8107 14.5202C23.1426 13.0778 23.1426 10.9222 21.8107 9.47978C20.0833 7.60905 16.8112 5 12 5ZM3.65868 10.8366C5.18832 9.18002 7.9669 7 12 7C16.0331 7 18.8117 9.18002 20.3413 10.8366C20.9657 11.5128 20.9657 12.4872 20.3413 13.1634C18.8117 14.82 16.0331 17 12 17C7.9669 17 5.18832 14.82 3.65868 13.1634C3.03426 12.4872 3.03426 11.5128 3.65868 10.8366Z"
                    fill="#ff6600" />
                </g>
              </svg>
            </span>
          }
        </div>
        @if (item?.comment_excerpt) {
          <div class="comment_excerpt">
            <i>
              <p>{{item?.comment_excerpt}}</p>
            </i>
          </div>
        }
        @if (item?.record_code
          ) {
          <div class="notification-code">
            <p>{{ item?.record_code ? item?.record_code : '--' }}</p>
          </div>
        }
      </div>
    </div>
  </div>
}
</div>
<!-- Loading bar -->
@if (isLoading) {
  <div style="height: 50px;" class="d-flex justify-content-center align-items-center py-1">
    <div class="  spinner-border text-dark" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
}
</div>

<!-- Footer -->
<!-- <div class="notification-footer" (click)="$event.stopPropagation()">
<button (click)="loadMoreData()" mat-button color="primary" class="view-all-btn">
  View all notifications
</button>

</div> -->
</mat-menu>
<!-- Mark all as read menu -->
<mat-menu #headerMenu="matMenu" [hasBackdrop]="false">
  <button mat-menu-item (click)=" notificationMarkAllAsRead($event)">
    <mat-icon>check_circle</mat-icon>
    <span>Mark all as read</span>
  </button>
</mat-menu>

<!-- Mark as unread menu -->
<mat-menu #markAsUnread="matMenu" class="notificationMarkAsUnreadMenu" [hasBackdrop]="false">
  <button mat-menu-item (click)="notificationMarkAsUnseen($event)">
    <span>Mark as unread</span>
  </button>
</mat-menu>